import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _bulkCreateLoyaltyTransactionsRequest = {
    loyaltyTransactions: '_loyaltyTransaction',
};
var _bulkCreateLoyaltyTransactionsResponse = {
    results: '_bulkLoyaltyTransactionResult',
};
var _bulkLoyaltyTransactionResult = { item: '_loyaltyTransaction' };
var _createLoyaltyTransactionRequest = {
    loyaltyTransaction: '_loyaltyTransaction',
};
var _createLoyaltyTransactionResponse = {
    loyaltyTransaction: '_loyaltyTransaction',
};
var _getLoyaltyTransactionRequest = {};
var _getLoyaltyTransactionResponse = {
    loyaltyTransaction: '_loyaltyTransaction',
};
var _loyaltyTransaction = { createdDate: 'google.protobuf.Timestamp' };
var _queryLoyaltyTransactionsRequest = {};
var _queryLoyaltyTransactionsResponse = {
    loyaltyTransactions: '_loyaltyTransaction',
};
function resolveWixLoyaltyTransactionV1LoyaltyTransactionsUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/loyalty-transactions',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/loyalty-transactions',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Creates a LoyaltyTransaction. */
export function createLoyaltyTransaction(payload) {
    var _a = serializer(_createLoyaltyTransactionRequest, { _loyaltyTransaction: _loyaltyTransaction }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createLoyaltyTransactionResponse, {
        _loyaltyTransaction: _loyaltyTransaction,
    }).fromJSON;
    function __createLoyaltyTransaction(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.transaction.v1.loyalty_transaction',
            method: 'POST',
            methodFqn: 'wix.loyalty.transaction.v1.LoyaltyTransactions.CreateLoyaltyTransaction',
            url: resolveWixLoyaltyTransactionV1LoyaltyTransactionsUrl({
                protoPath: '/v1/loyalty-transactions',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createLoyaltyTransaction.fromReq = fromReq;
    __createLoyaltyTransaction.__isAmbassador = true;
    return __createLoyaltyTransaction;
}
/** Creates up to 100 loyalty transactions. */
export function bulkCreateLoyaltyTransactions(payload) {
    var _a = serializer(_bulkCreateLoyaltyTransactionsRequest, { _loyaltyTransaction: _loyaltyTransaction }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkCreateLoyaltyTransactionsResponse, { _bulkLoyaltyTransactionResult: _bulkLoyaltyTransactionResult, _loyaltyTransaction: _loyaltyTransaction }).fromJSON;
    function __bulkCreateLoyaltyTransactions(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.transaction.v1.loyalty_transaction',
            method: 'POST',
            methodFqn: 'wix.loyalty.transaction.v1.LoyaltyTransactions.BulkCreateLoyaltyTransactions',
            url: resolveWixLoyaltyTransactionV1LoyaltyTransactionsUrl({
                protoPath: '/v1/bulk/loyalty-transactions/create',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkCreateLoyaltyTransactions.fromReq = fromReq;
    __bulkCreateLoyaltyTransactions.__isAmbassador = true;
    return __bulkCreateLoyaltyTransactions;
}
/** Retrieves a transaction. */
export function getLoyaltyTransaction(payload) {
    var _a = serializer(_getLoyaltyTransactionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getLoyaltyTransactionResponse, {
        _loyaltyTransaction: _loyaltyTransaction,
    }).fromJSON;
    function __getLoyaltyTransaction(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.transaction.v1.loyalty_transaction',
            method: 'GET',
            methodFqn: 'wix.loyalty.transaction.v1.LoyaltyTransactions.GetLoyaltyTransaction',
            url: resolveWixLoyaltyTransactionV1LoyaltyTransactionsUrl({
                protoPath: '/v1/loyalty-transactions/{loyaltyTransactionId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getLoyaltyTransaction.fromReq = fromReq;
    __getLoyaltyTransaction.__isAmbassador = true;
    return __getLoyaltyTransaction;
}
/**
 * Retrieves a list of loyalty transactions, given the provided [paging, filtering, and sorting][1].
 *
 * Supported fields for filtering and sorting:
 * `id`, `accountId`, `idempotencyKey`, `transactionType`, `amount`, `description`
 *
 * To learn how to query Loyalty Transactions, see [API Query Language][2].
 *
 * [1]: https://dev.wix.com/api/rest/getting-started/sorting-and-paging
 * [2]: https://dev.wix.com/api/rest/getting-started/api-query-language
 */
export function queryLoyaltyTransactions(payload) {
    var _a = serializer(_queryLoyaltyTransactionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryLoyaltyTransactionsResponse, {
        _loyaltyTransaction: _loyaltyTransaction,
    }).fromJSON;
    function __queryLoyaltyTransactions(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.transaction.v1.loyalty_transaction',
            method: 'POST',
            methodFqn: 'wix.loyalty.transaction.v1.LoyaltyTransactions.QueryLoyaltyTransactions',
            url: resolveWixLoyaltyTransactionV1LoyaltyTransactionsUrl({
                protoPath: '/v1/loyalty-transactions/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryLoyaltyTransactions.fromReq = fromReq;
    __queryLoyaltyTransactions.__isAmbassador = true;
    return __queryLoyaltyTransactions;
}
//# sourceMappingURL=http.impl.js.map